import MessagePortal from './portal'

export default MessagePortal